export default __webpack_public_path__ + "static/media/849cff9e55b3f9c522efa8cb041a3f3b.png";